import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../header';
import MainMenu from '../main-menu';
import {
  AuthActions,
  AuthSelectors,
  UserInfoSelectors,
  apiVersionActions,
  apiVersionSelectors,
} from '../../../common/config/store';

type Props = {
  login?: boolean;
};

const Layout: React.FC<Props> = ({ login }: Props) => {
  const isAuth = useSelector(AuthSelectors.isAuthSelector);
  const isUpcomingPasswordExpiry = useSelector(UserInfoSelectors.isUpcomingPasswordExpirySelector);
  const fullUserName = useSelector(UserInfoSelectors.fullNameSelector);
  const apiVersion = useSelector(apiVersionSelectors.apiVersionSelector);
  const canReadCirculations = useSelector(UserInfoSelectors.hasReadAccess('Circulations'));
  const canReadCustomerFlux = useSelector(UserInfoSelectors.hasReadAccess('Customer-Flux'));
  const canReadHistorisation = useSelector(UserInfoSelectors.hasReadAccess('Historisation'));

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(apiVersionActions.fetchApiVersion());
  }, [dispatch]);

  const handleLogOut = (e: React.SyntheticEvent) => {
    e.preventDefault();
    dispatch(AuthActions.logout());
  };

  return (
    <div>
      <Header
        showUpcomingPasswordExpiryMessage={isUpcomingPasswordExpiry}
        fullUserName={isAuth ? fullUserName : undefined}
        logOutAction={handleLogOut}
        login={login}
        version={apiVersion?.version}
        readAccesses={{
          canReadCirculations,
          canReadCustomerFlux,
          canReadHistorisation,
        }}
      />
      {isAuth && <MainMenu />}
    </div>
  );
};

export default Layout;
